import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex align-items-center justify-content-between mx-0 mt-3 mb-1" }
const _hoisted_2 = { class: "radio-group flex flex-row align-items-center" }
const _hoisted_3 = { class: "flex flex-row align-items-center justify-content-between" }
const _hoisted_4 = { class: "radio-group flex flex-row align-items-center" }
const _hoisted_5 = { class: "p-error" }

import { computed, inject, ref, Ref, toRefs } from 'vue';
import RadioButton from 'primevue/radiobutton';
import useVuelidate from '@vuelidate/core';
import { required, helpers } from '@vuelidate/validators';

import { useOrganizationContractsStore } from '@/store';
import { CONTRACT_ENUMS } from '@/enum';
import { ContractDetailInterface } from '@/types';

interface Props {
  contract: ContractDetailInterface;
  scope: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OrganizationContractNoShow',
  props: {
    contract: {},
    scope: {}
  },
  setup(__props: any) {

const contractStore = useOrganizationContractsStore();
const props = __props;
const { contract, scope } = toRefs(props);
const selectedMainForm = inject<Ref<CONTRACT_ENUMS.FORMS>>('selectedForm', ref(CONTRACT_ENUMS.FORMS.FLAT_FEE));
const canEdit = contractStore.canEditOrCreateContracts;

const noShowRatePercentage = computed<number>({
  get() {
    return contract.value.noshow_is_fixed ? 0 : (contract.value.noshow_rate as number);
  },
  set(value) {
    contract.value.noshow_rate = value;
  },
});

const noShowRateFlatFee = computed<number>({
  get() {
    return !contract.value.noshow_is_fixed ? 0 : (contract.value.noshow_rate as number);
  },
  set(value) {
    contract.value.noshow_rate = value;
  },
});

const rules = computed(() => {
  return {
    noshow_is_fixed: {
      required,
    },
    noshow_rate: {
      required: helpers.withMessage('Please provide the no show/late cancel rate or percentage', required),
    },
  };
});

const v$ = useVuelidate(rules, contract, { $scope: scope.value });

return (_ctx: any,_cache: any) => {
  const _component_InputNumber = _resolveComponent("InputNumber")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["p-3 w-full border-round-lg bg-gray-50 no-show-container", { flat: _unref(selectedMainForm) !== _unref(CONTRACT_ENUMS).FORMS.HOURLY }])
  }, [
    _cache[12] || (_cache[12] = _createElementVNode("label", { class: "required" }, [
      _createElementVNode("b", null, "No Show/Late Cancel")
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(RadioButton), {
          modelValue: _unref(contract).noshow_is_fixed,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((_unref(contract).noshow_is_fixed) = $event)),
            _cache[1] || (_cache[1] = () => (_unref(contract).noshow_rate = 0))
          ],
          "input-id": "fee_percentage",
          value: 0,
          name: "fee_percentage",
          class: _normalizeClass(["mr-1 relative", { 'p-invalid': _unref(v$).noshow_is_fixed.$invalid && _unref(v$).noshow_is_fixed.$dirty }]),
          disabled: !_unref(canEdit)
        }, null, 8, ["modelValue", "class", "disabled"]),
        _cache[10] || (_cache[10] = _createElementVNode("label", {
          class: "m-1",
          for: "fee_percentage"
        }, "Percentage", -1))
      ]),
      _createVNode(_component_InputNumber, {
        modelValue: noShowRatePercentage.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((noShowRatePercentage).value = $event)),
        max: 100,
        min: 0,
        "max-fraction-digits": 2,
        "min-fraction-digits": 0,
        mode: "decimal",
        suffix: "%",
        disabled: _unref(contract).noshow_is_fixed === 1 || !_unref(canEdit),
        "input-class": "border-none",
        "input-style": { padding: '1px 7px' },
        class: _normalizeClass({ 'p-invalid': _unref(v$).noshow_rate.$invalid && _unref(v$).noshow_rate.$dirty }),
        onBlur: _cache[3] || (_cache[3] = ($event: any) => (_unref(v$).noshow_rate.$touch())),
        onFocus: _cache[4] || (_cache[4] = (e) => e?.target?.select())
      }, null, 8, ["modelValue", "disabled", "class"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(RadioButton), {
          modelValue: _unref(contract).noshow_is_fixed,
          "onUpdate:modelValue": [
            _cache[5] || (_cache[5] = ($event: any) => ((_unref(contract).noshow_is_fixed) = $event)),
            _cache[6] || (_cache[6] = () => (_unref(contract).noshow_rate = 0))
          ],
          "input-id": "fee_flat_fee",
          value: 1,
          name: "fee_flat",
          class: _normalizeClass(["mr-1 relative", { 'p-invalid': _unref(v$).noshow_is_fixed.$invalid && _unref(v$).noshow_is_fixed.$dirty }]),
          disabled: !_unref(canEdit)
        }, null, 8, ["modelValue", "class", "disabled"]),
        _cache[11] || (_cache[11] = _createElementVNode("label", {
          class: "m-1",
          for: "fee_flat_fee"
        }, "Flat Fee", -1))
      ]),
      _createVNode(_component_InputNumber, {
        modelValue: noShowRateFlatFee.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((noShowRateFlatFee).value = $event)),
        mode: "currency",
        currency: "USD",
        "input-class": "border-none",
        "input-style": { padding: '1px 7px' },
        disabled: _unref(contract).noshow_is_fixed === 0 || !_unref(canEdit),
        class: _normalizeClass({ 'p-invalid': _unref(v$).noshow_rate.$invalid && _unref(v$).noshow_rate.$dirty }),
        onBlur: _cache[8] || (_cache[8] = ($event: any) => (_unref(v$).noshow_rate.$touch())),
        onFocus: _cache[9] || (_cache[9] = (e) => e?.target?.select())
      }, null, 8, ["modelValue", "disabled", "class"])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
      return (_openBlock(), _createElementBlock("div", {
        key: error.$uid,
        class: "input-errors mt-2 text-align-left w-6"
      }, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(error.$message), 1)
      ]))
    }), 128))
  ], 2))
}
}

})